import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import Loader from "./../child/Loder";
import moment from "moment";

const ViewSubadminPageNew = () => {
  const [imagePreview, setImagePreview] = useState(
    "assets/images/user-grid/user-grid-img13.png"
  );
  const [adminRole, setAdminRole] = useState("");

  const [Name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState({});
  const [Modulename, setModuleData] = useState([]);
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
  const [AdminData, setAdminData] = useState([]);
  const [UserData, setUserData] = useState([]);
  const { id } = useParams();
  const isEditMode = !!id;

  const navigate = useNavigate();

  const handleCheckboxChange = (id, permission) => {
    const updatedPermissions = { ...selectedPermissions };

    // Check if we're updating the main checkbox (i.e., the module checkbox)
    if (permission === "selected") {
      const newCheckedState = !updatedPermissions[id]?.selected;
      updatedPermissions[id] = {
        selected: newCheckedState,
        add: newCheckedState,
        edit: newCheckedState,
        view: newCheckedState,
        delete: newCheckedState,
        review: newCheckedState,
      };
    } else {
      // Otherwise, just update the individual permission
      updatedPermissions[id] = {
        ...updatedPermissions[id],
        [permission]: !updatedPermissions[id][permission],
      };
    }

    // Set the new state
    setSelectedPermissions(updatedPermissions);
  };
  useEffect(() => {
    const fetchModuleData = async () => {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/moduleList`;
      try {
        setLoading(true);
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch modules");
        }

        const data = await response.json();

        setModuleData(data.modules || []);
      } catch (err) {
        setErrorMessage(err.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    fetchModuleData();
  }, []);

  useEffect(() => {
    if (!id) return; // Ensure id is defined before making the request

    const fetchAdminData = async () => {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/adminById/${id}`;
      try {
        setLoading(true);
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch admin data");
        }

        const data = await response.json();

        setUserData(data.result);
        setAdminRole(data?.result?.role || "");
        setName(data.result.name || "");
        setEmail(data.result.email || "");

        setImagePreview(data.result.profilePicture || "");
        setPhone((data.result.dialCode || "") + (data.result.phone || ""));

        // Ensure permissions are formatted correctly
        if (data.result.permissions) {
          const formattedPermissions = {};
          data.result.permissions.forEach((permission) => {
            formattedPermissions[permission.module] = {
              selected:
                permission.add ||
                permission.edit ||
                permission.view ||
                permission.delete ||
                permission.review,
              // Auto-select if any permission is true
              add: permission.add || false,
              edit: permission.edit || false,
              view: permission.view || false,
              delete: permission.delete || false,
              review: permission.review || false,
            };
          });

          setSelectedPermissions(formattedPermissions);
        }

        setAdminData(data); // Assuming 'data' contains the admin details
      } catch (err) {
        setErrorMessage(err.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    fetchAdminData();
  }, [isEditMode, id, navigate]); // Ensures the effect runs when id, edit mode, or navigation changes

  const roleMap = {
    support_admin: "Support Admin",
    content_moderator: "Content Moderator",
    customer_support: "Customer Support",
  };

  if (loading) return <Loader />;

  return (
    <div className="row gy-4">
      <div className="col-lg-4">
        {successMessage && (
          <SuccessAlert
            message={successMessage}
            onClose={() => setSuccessMessage("")}
          />
        )}
        {errorMessage && (
          <DengerAlert
            message={errorMessage}
            onClose={() => setErrorMessage("")}
          />
        )}
      </div>
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link d-flex align-items-center px-24 active"
                  id="pills-edit-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-edit-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-edit-profile"
                  aria-selected="true"
                >
                  Personal Information
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link d-flex align-items-center px-24"
                  id="pills-change-passwork-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-change-passwork"
                  type="button"
                  role="tab"
                  aria-controls="pills-change-passwork"
                  aria-selected="false"
                  tabIndex={-1}
                >
                  Module Access
                </button>
              </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-edit-profile"
                role="tabpanel"
                aria-labelledby="pills-edit-profile-tab"
                tabIndex={0}
              >
                <h6 className="text-md text-primary-light mb-16">
                  Profile Image
                </h6>
                <form action="#">
                  {/* Upload Image Start */}
                  <div className="mb-24 mt-16">
                    <div className="avatar-upload">
                      <div className="avatar-preview">
                        <div
                          id="imagePreview"
                          style={{
                            backgroundImage: `url(${imagePreview})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Upload Image End */}

                  <div className="row">
                    <div className="col-sm-4">
                      <div className="mb-20">
                        <span>
                          <b>Role : </b>
                        </span>
                        {/* <p> {adminRole}</p> */}
                        <p>{roleMap[adminRole] || "N/A"}</p>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="mb-20">
                        <span>
                          <b>Full Name : </b>
                        </span>
                        <p> {Name}</p>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="mb-20">
                        <span>
                          <b>Phone Number :</b>
                        </span>
                        <p> +{phone}</p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="mb-20">
                        <span>
                          <b>Email :</b>
                        </span>

                        <p> {email}</p>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="mb-20">
                        <span>
                          <b>Created At :</b>
                        </span>
                        <p>{moment(UserData.createdAt).format("DD-MM-YYYY")}</p>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div
                className="tab-pane fade"
                id="pills-change-passwork"
                role="tabpanel"
                aria-labelledby="pills-change-passwork-tab"
                tabIndex="0"
              >
                <form action="#">
                  <div className="">
                    <div className="table-responsive">
                      <table className="table basic-border-table mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Module Name</th>
                            <th>Add</th>
                            <th>Edit</th>
                            <th>View</th>
                            <th>Delete</th>
                            <th>Review</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Modulename.length > 0 ? (
                            Modulename.filter(
                              (item) =>
                                item.permissions &&
                                (item.permissions.add ||
                                  item.permissions.edit ||
                                  item.permissions.view ||
                                  item.permissions.delete ||
                                  item.permissions.review)
                            ).map((item) => {
                              const validPermissions = Object.entries(
                                item.permissions
                              ).filter(([key, value]) => value);

                              return (
                                <tr key={item._id}>
                                  <td>
                                    <input
                                      className="form-check-input radius-4 border input-form-dark"
                                      type="checkbox"
                                      id={`module_${item._id}`}
                                      checked={
                                        selectedPermissions[item._id]
                                          ?.selected || false
                                      }
                                      onChange={() =>
                                        handleCheckboxChange(
                                          item._id,
                                          "selected"
                                        )
                                      }
                                      disabled
                                    />
                                  </td>
                                  <td>
                                    {
                                      item.title === "Space Type"
                                        ? "Storage Type"
                                        : item.title === "chatpayment"
                                          ? "Chat Payment"
                                          : item.title === "transaction-promotion"
                                            ? "Promotion Payment"
                                            : item.title === "booking"
                                              ? "Booking"
                                              : item.title === "supportticket"
                                                ? "Help & Support Ticket"
                                                : item.title === "vault-questions"
                                                  ? "Vault Questions"
                                                  : item.title === "preferences"
                                                    ? "Preferences"
                                                    : item.title === "discovery-config"
                                                      ? "Compatibility Algorithm"
                                                      : item.title === "notification"
                                                        ? "Notification"
                                                        : item.title === "mynotification"
                                                          ? "My Notification"
                                                          : item.title === "user-report"
                                                            ? "User Report"
                                                            : item.title === "feature-requests"
                                                              ? "Feature Requests"
                                                              : item.title === "analytics-reporting"
                                                                ? "Analytics Reporting"
                                                                : item.title === "payments-transactions"
                                                                  ? "Payment and Transactions"
                                                                  : item.title === "subscriptions"
                                                                    ? "Subscriptions"
                                                                    : item.title === "help-supports"
                                                                      ? "Help And Supports"
                                                                                                                                              : item.title === "admin-settings"
                                                                          ? "Settings"
                                                                        
                                                                        : item.title}
                                  </td>

                                  {validPermissions.length > 0 ? (
                                    <>
                                      <td>
                                        {item.permissions.add ? (
                                          <input
                                            className="form-check-input radius-4 border input-form-dark"
                                            type="checkbox"
                                            id={`add_${item._id}`}
                                            checked={
                                              selectedPermissions[item._id]
                                                ?.add || false
                                            }
                                            onChange={() =>
                                              handleCheckboxChange(
                                                item._id,
                                                "add"
                                              )
                                            }
                                            disabled
                                          />
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      <td>
                                        {item.permissions.edit ? (
                                          <input
                                            className="form-check-input radius-4 border input-form-dark"
                                            type="checkbox"
                                            id={`edit_${item._id}`}
                                            checked={
                                              selectedPermissions[item._id]
                                                ?.edit || false
                                            }
                                            onChange={() =>
                                              handleCheckboxChange(
                                                item._id,
                                                "edit"
                                              )
                                            }
                                            disabled
                                          />
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      <td>
                                        {item.permissions.view ? (
                                          <input
                                            className="form-check-input radius-4 border input-form-dark"
                                            type="checkbox"
                                            id={`view_${item._id}`}
                                            checked={
                                              selectedPermissions[item._id]
                                                ?.view || false
                                            }
                                            onChange={() =>
                                              handleCheckboxChange(
                                                item._id,
                                                "view"
                                              )
                                            }
                                            disabled
                                          />
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      <td>
                                        {item.permissions.delete ? (
                                          <input
                                            className="form-check-input radius-4 border input-form-dark"
                                            type="checkbox"
                                            id={`delete_${item._id}`}
                                            checked={
                                              selectedPermissions[item._id]
                                                ?.delete || false
                                            }
                                            onChange={() =>
                                              handleCheckboxChange(
                                                item._id,
                                                "delete"
                                              )
                                            }
                                            disabled
                                          />
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      <td>
                                        {item.permissions.review ? (
                                          <input
                                            className="form-check-input radius-4 border input-form-dark"
                                            type="checkbox"
                                            id={`review_${item._id}`}
                                            checked={
                                              selectedPermissions[item._id]
                                                ?.review || false
                                            }
                                            onChange={() =>
                                              handleCheckboxChange(
                                                item._id,
                                                "review"
                                              )
                                            }
                                            disabled
                                          />
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                    </>
                                  ) : (
                                    <>
                                      <td>-</td>
                                      <td>-</td>
                                      <td>-</td>
                                      <td>-</td>
                                      <td>-</td>
                                    </>
                                  )}
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No Modules Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSubadminPageNew;
